<div class="content-wrapper">
    <div class="career-banner" data-aos="fade-up" data-aos-duration="800" data-aos-easing="ease-in-out">
        <section class='hero-header'>
            <div class="container">
                <p class="font-size-18 uppercase text-white font-weight-medium text-center pb-3" data-aos="zoom-in-up" data-aos-duration="800" data-aos-easing="ease-in-out">{{'Career' | translate}}</p>
                <h2 class="display-5 text-color font-weight-semibold text-center text-white" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                    {{"Let's Work Together To Create More Fantasy" | translate}}
                </h2>
                <div class="d-flex align-items-center justify-content-center" data-aos="zoom-in" data-aos-duration="800" data-aos-easing="ease-in-out">
                    <a class="pulse white-bg btn font-size-14 text-dark rounded-0 px-5 py-3" [routerLink]="['/contact']">{{'Join Us Now' | translate}}</a>
                </div>
            </div>
        </section>
    </div>
</div>